import { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { Info } from 'lucide-react';
import { sek } from './crmUtils';

const API = process.env.REACT_APP_BACKEND_URL;

export function SalesStats({ token, refreshKey }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/sales/crm/stats`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => (r.ok ? r.json() : null)).then(setS).catch(() => setS(null));
  }, [token, refreshKey]);
  if (!s) return <p className="text-sm text-muted-foreground py-6">Laddar statistik...</p>;
  const t = s.totals;
  const tiles = [
    ['Leads totalt', t.leads], ['Kontaktade', t.contacted], ['Kundsvar', t.replies], ['Demos', t.demos],
    ['Skickade offerter (alla kunder)', t.quotes_sent], ['Vunna affärer', t.won], ['Förlorade affärer', t.lost], ['Sålda sensorer', t.sensors_sold],
    ['Försäljningsvärde', sek(t.sales_value)], ['Årliga licensintäkter', `${sek(t.annual_license)}/år`],
  ];
  const funnel = s.funnel;
  return (
    <div className="space-y-5" data-testid="sales-stats">
      {s.history_note && (
        <div className="flex gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs text-amber-900" data-testid="stats-history-note">
          <Info className="h-4 w-4 shrink-0" /> {s.history_note}
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {tiles.map(([l, v]) => (
          <div key={l} className="rounded-xl border bg-card p-3" data-testid={`stat-${l}`}>
            <div className="text-xl font-extrabold tracking-tight">{v}</div>
            <div className="text-xs text-muted-foreground">{l}</div>
          </div>
        ))}
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="rounded-xl border bg-card p-4">
          <h3 className="text-sm font-semibold mb-3">Nya leads per månad</h3>
          {s.new_per_month.length === 0 ? <p className="text-xs text-muted-foreground">Ingen data ännu.</p> : (
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={s.new_per_month}><CartesianGrid strokeDasharray="3 3" vertical={false} /><XAxis dataKey="month" fontSize={11} /><YAxis allowDecimals={false} fontSize={11} width={28} /><Tooltip /><Bar dataKey="count" name="Nya leads" fill="#2563eb" radius={[4, 4, 0, 0]} /></BarChart>
            </ResponsiveContainer>
          )}
        </div>
        <div className="rounded-xl border bg-card p-4" data-testid="stats-funnel">
          <h3 className="text-sm font-semibold mb-3">Konvertering mellan stegen</h3>
          <div className="space-y-2">
            {funnel.map((f, i) => {
              const max = Math.max(1, funnel[0].count);
              const prev = i > 0 ? funnel[i - 1].count : null;
              return (
                <div key={f.key} className="text-xs">
                  <div className="flex justify-between mb-0.5"><span>{f.label}</span>
                    <span className="text-muted-foreground">{f.count}{prev ? ` · ${Math.round((f.count / prev) * 100)} % från föregående` : prev === 0 && i > 0 ? ' · –' : ''}</span>
                  </div>
                  <div className="h-2.5 rounded-full bg-muted overflow-hidden"><div className="h-full bg-blue-600 rounded-full" style={{ width: `${(f.count / max) * 100}%` }} /></div>
                </div>
              );
            })}
          </div>
          <p className="text-[11px] text-muted-foreground mt-3">Beräknat från registrerade aktiviteter, statusändringar och offerter – inte historiska branschsiffror.</p>
        </div>
      </div>
    </div>
  );
}
